module.exports = __webpack_public_path__ + "static/media/ab1.df8eff40.webp";